import type {
  LeaderboardPodiumSlot,
  LeaderboardRankingRow,
} from '../../../domain/leaderboard/models/public-leaderboard.model';
import {
  computeLeaderboardRowProgress,
  type LeaderboardProgressContext,
} from '../../../domain/leaderboard/utils/compute-leaderboard-progress-percent';
import type { PublicRankingItemApiDto } from '../dtos/leaderboard-public-api.dto';

function mapItem(item: PublicRankingItemApiDto, progressCtx: LeaderboardProgressContext): LeaderboardRankingRow {
  const label = String(item.display_name ?? '').trim() || 'Participante';
  const xp = item.xp ?? 0;
  return {
    rank: item.rank,
    anonymousId: label,
    xp,
    progressPercent: computeLeaderboardRowProgress(xp, progressCtx),
    isWinner: Boolean(item.is_winner),
  };
}

export interface MappedRanking {
  podium: LeaderboardPodiumSlot[];
  ranking: LeaderboardRankingRow[];
}

export function mapRankingItemsFromApi(
  items: PublicRankingItemApiDto[] | undefined,
  progressCtx?: LeaderboardProgressContext,
): MappedRanking | null {
  if (!Array.isArray(items) || items.length === 0) {
    return { podium: [], ranking: [] };
  }
  const sorted = [...items].sort((a, b) => a.rank - b.rank);
  const leaderXp = sorted.find((r) => r.rank === 1)?.xp ?? sorted[0]?.xp ?? 0;
  const ctx: LeaderboardProgressContext = progressCtx ?? {
    activityType: 'competitive',
    leaderXp,
  };
  const rows = sorted.map((item) => mapItem(item, { ...ctx, leaderXp: ctx.leaderXp || leaderXp }));

  const podium: LeaderboardPodiumSlot[] = [];
  for (const rank of [1, 2, 3] as const) {
    const row = rows.find((r) => r.rank === rank);
    if (row) {
      podium.push({ rank, label: row.anonymousId, xp: row.xp });
    }
  }

  return { podium, ranking: rows };
}
